import React, { type ReactNode } from 'react'

import * as S from './Layout.styled'
import type { LayoutAppearance } from './Layout.types'

type LayoutProps = {
  appearance?: LayoutAppearance
  content: ReactNode
  contentHeader: ReactNode
  contentFooter: ReactNode
  contentFooterTop?: ReactNode
  contentFooterLeft?: ReactNode
  contentFooterRight?: ReactNode
  sidebar: ReactNode
}

export const Layout = ({
  appearance = 'DARK',
  content,
  contentHeader,
  contentFooter,
  contentFooterTop,
  contentFooterLeft,
  contentFooterRight,
  sidebar,
}: LayoutProps) => {
  return (
    <S.Container>
      <S.MainContent appearance={appearance}>
        <div>
          <S.MainHeader>{contentHeader}</S.MainHeader>
          <S.Content>{content}</S.Content>
          <S.MainFooter>
            <S.MainFooterLeft>{contentFooterLeft}</S.MainFooterLeft>
            <S.MainFooterTop>{contentFooterTop}</S.MainFooterTop>
            <S.MainFooterContent>{contentFooter}</S.MainFooterContent>
            <S.MainFooterRight>{contentFooterRight}</S.MainFooterRight>
          </S.MainFooter>
        </div>
      </S.MainContent>
      {sidebar && <S.SidebarContent>{sidebar}</S.SidebarContent>}
    </S.Container>
  )
}
